import React, {useEffect, useState} from "react";
import ListAllPicturesComponent from "../../editComponents/ListAllPicturesComponent";
import firebase from "firebase";
import axios from 'axios'
import fileDownload from "js-file-download";
import {storage} from "../../firebase";

function ListAllPicturesPage(
    {
        setEditSelected,
        setEditPictures
    }
) {

    const [progress, setProgress] = useState(0);
    const [progressText, setProgressText] = useState('');
    const [loading, setLoading] = useState(true);
    const [pictures] = useState([]);

    useEffect(() => {
        async function fetchSounds() {
            await firebase.storage().ref().child('pictures').listAll()
                .then((data) => {
                    data.items.forEach((fileRef) => {
                        fileRef.getDownloadURL().then((url) => {
                                pictures.push(
                                    {
                                        name: fileRef.location.path_.split('/')[1],
                                        file: url
                                    });
                                setProgress(prevState => prevState + Math.round(100/data.items.length));
                                setProgressText('Loading Pictures')

                            }
                        )


                    })
                }).catch(e => console.log(e));

        }

        fetchSounds().then(() => setLoading(false))
    }, []);

    const handleGoBack = () => {
        setEditSelected(false);
        setEditPictures(false);
    };

    const handleDownload = (url, filename) => {
        axios.get(url, {
            responseType: 'blob',
        })
            .then((res) => {
                fileDownload(res.data, filename)
            })
    };

    return (
        <>
            <ListAllPicturesComponent
                handleGoBack={handleGoBack}
                pictures={pictures}
                handleDownload={handleDownload}
                progress={progress}
                progressText={progressText}
                loading={loading}
            />
        </>
    )
}

export default ListAllPicturesPage
